import {
  TextField,
  Typography,
} from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from '@gamiphy/react-i18n';
import { Control, Controller } from 'react-hook-form';
import { BRAZIL_PHONE_VALIDATION_REGEX } from '@gamiphy/loyalty/loyaltyPage/components/cashbackProgram/verification';
import { UserInfoFormValues } from './types';

const PhoneField: React.FC<{control: Control<UserInfoFormValues>}> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <Controller
      name="phone"
      control={control}
      rules={{
        required: {
          value: true,
          message: t('validation.required', { defaultValue: 'This field is required' }),
        },
        pattern: {
          value: BRAZIL_PHONE_VALIDATION_REGEX,
          message: t('coreloyalty.cashback.phone.invalidDigits', 'Please enter a valid 10 or 11-digit phone number.'),
        },
      }}
      render={({
        fieldState: { error },
        field: {
          value,
          onChange,
        },
      }) => (
        <TextField
          variant="standard"
          placeholder={t('user.name.phoneNumber', 'Phone Number')}
          error={!!error}
          autoFocus
          value={value ?? ''}
          onChange={onChange}
          helperText={error?.message}
          InputProps={{
            disableUnderline: true,
            startAdornment: (
              <Typography fontSize={14} fontWeight={400} color="#525D6A" lineHeight={1} px={2}>
                +55
              </Typography>
            ),
            sx: {
              bgcolor: '#E5E5E5',
              py: 1,
              pr: 2,
              borderRadius: 0.5,
              fontSize: 16,
            },
            inputProps: {
              sx: {
                '&::placeholder': {
                  fontSize: '1.5rem',
                },
              },
            },
          }}
        />
      )}
    />

  );
};

export default observer(PhoneField);
